import styles from './events.module.css';
import { useEffect, useState } from 'react';
import ImageOverlay from '../ImageOverLay/ImageOverlay';
import { eventosLogic, IEvento } from '../../../Logic/Eventos';

export default function Events() {

  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null); // Para la foto seleccionada en el modal
  const [eventos, setEventos] = useState<IEvento[]>([]); // Estado para almacenar los eventos
  const [error, setError] = useState<string | null>(null); // Estado para manejar errores

  // Realizar la petición GET al cargar el componente
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        await eventosLogic.GetEvents().then(response => {
          console.log(response)
            if (response.length === 0) {
              setError("No hay eventos que mostrar");
            } else {
              setEventos(response); // Asignamos la respuesta a la variable de eventos
              setError(null); // Limpiamos cualquier error si hay eventos
            }
         })
      } catch (error) {
        console.error("Error al obtener los eventos:", error);
        setError("Hubo un problema al obtener los eventos. Intenta de nuevo más tarde.");
      }
    };

    fetchEventos(); // Ejecutamos la función de obtención de eventos
  }, []);

  return (
    <>
      <h1 className={styles.titleSection}>Próximos eventos</h1>
      <div className={styles.container}>
        {/* Verificamos si hay error o si no hay eventos */}
        {error ? (
          <div className={styles.errorMessage}>
            {error}
          </div>
        ) : (
          <>
            <div className={styles.mural}>
              {eventos.map((evento, index) => (
                <ImageOverlay
                  key={index}
                  src={evento.Imagen}
                  alt={evento.Nombre}
                  isImgEvent={true}
                  text="Ver"
                  onClick={() => setSelectedPhoto(evento.Imagen)} // Abrir el modal al hacer clic
                />
              ))}
            </div>
             <a target="_blank"
            href="https://wa.me/+522221517369?text=Hola%20me interesa%20mas%20informacion%20sobre%20el%20evento%20de:"
            className={styles.mainButton}
            >
            CONTÁCTANOS
            </a>
          </>
        )}
       

        {/* Modal de visualización de imagen */}
        {selectedPhoto && (
          <div className={styles.modal} onClick={() => setSelectedPhoto(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <img src={selectedPhoto} alt="Imagen seleccionada" className={styles.modalImage} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
